import { render, staticRenderFns } from "./BaseImg.vue?vue&type=template&id=2c57cb63&scoped=true"
import script from "./BaseImg.vue?vue&type=script&lang=ts"
export * from "./BaseImg.vue?vue&type=script&lang=ts"
import style0 from "./BaseImg.vue?vue&type=style&index=0&id=2c57cb63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c57cb63",
  null
  
)

export default component.exports